export default __webpack_public_path__ + "static/media/ag-icon-active.d160019f.svg";